import { ChevronDown } from 'lucide-react';
import { useId, useState, type ReactNode } from 'react';
import styles from './MoreOptions.module.css';

/**
 * QoL §7 form layout rule 4 (R3): fields most people never touch sit under "More options",
 * closed by default. A plain disclosure button, so the keyboard and screen readers know it.
 */
export function MoreOptions({
  label = 'More options',
  isInitiallyOpen = false,
  children,
}: {
  readonly label?: string;
  /** Open from the start when something inside is already filled in, so a set value is never hidden. */
  readonly isInitiallyOpen?: boolean;
  readonly children: ReactNode;
}): ReactNode {
  const [isOpen, setIsOpen] = useState(isInitiallyOpen);
  const regionId = useId();
  return (
    <div className={styles.wrap}>
      <button type="button" className={styles.toggle} aria-expanded={isOpen} aria-controls={regionId} onClick={() => setIsOpen((open) => !open)}>
        <span className={styles.chevron} aria-hidden>
          <ChevronDown size={16} />
        </span>
        {label}
      </button>
      {isOpen && (
        <div id={regionId} className={styles.region}>
          {children}
        </div>
      )}
    </div>
  );
}
